var map = {
	"./attendance.png": "b005",
	"./employManage.png": "9d9a",
	"./expressage.png": "c33e",
	"./invoice.png": "2384",
	"./keding.png": "8589",
	"./money.png": "38ba8",
	"./music.png": "046d",
	"./priceAdjustment.png": "f711",
	"./scheduling.png": "0ce1",
	"./stock.png": "45fa",
	"./timeQuantum.png": "4a73",
	"./workorder.png": "3177",
	"./yejicalendar.png": "f103"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";